import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Stamp from './layout/Stamp';

const MentorBookingSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [bookingDetails, setBookingDetails] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifyPayment = async () => {
      if (!sessionId) {
        setError('No session ID found');
        setLoading(false);
        return;
      }

      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
      const token = localStorage.getItem('token');

      try {
        const response = await axios.post(
          `${API_BASE_URL}/mentors/verify-session-payment`,
          { sessionId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setBookingDetails(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error verifying payment:', err);
        setError('Failed to verify payment. Please contact support.');
        setLoading(false);
      }
    };

    verifyPayment();
  }, [sessionId]);

  if (loading) {
    return (
      <div className="section" style={{ paddingTop: 64 }}>
        <div className="wrap" style={{ maxWidth: 560 }}>
          <div className="card" style={{ padding: 40 }}>
            <h2 style={{ marginBottom: 8 }}>Verifying payment…</h2>
            <p className="meta">Hold on while we confirm your booking with Stripe.</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="section" style={{ paddingTop: 64 }}>
        <div className="wrap" style={{ maxWidth: 560 }}>
          <div className="card" style={{ padding: 40 }}>
            <h2 style={{ marginBottom: 8 }}>Payment verification failed</h2>
            <p className="meta" style={{ marginBottom: 20 }}>{error}</p>
            <button className="btn btn-primary" onClick={() => navigate('/mentors')}>
              Back to mentors
            </button>
          </div>
        </div>
      </div>
    );
  }

  const packageLabel =
    bookingDetails?.packageName ||
    (bookingDetails?.packageType === 'custom' ? 'Package' : 'Hourly session');

  return (
    <div className="section" style={{ paddingTop: 64 }}>
      <div className="wrap" style={{ maxWidth: 560 }}>
        <div className="card" style={{ padding: 40 }}>
          <Stamp variant="verified" style={{ marginBottom: 16 }}>
            Booked — pending mentor confirmation
          </Stamp>
          <h2 style={{ margin: '8px 0' }}>
            {bookingDetails?.selectedDate && bookingDetails?.selectedTime
              ? `${bookingDetails.selectedDate} at ${bookingDetails.selectedTime}`
              : 'Your session is booked'}
          </h2>
          <p className="meta" style={{ marginBottom: 20 }}>
            {packageLabel}
            {bookingDetails?.mentorName ? ` with ${bookingDetails.mentorName}` : ''}
            {bookingDetails?.sessionsCount > 1
              ? ` · ${bookingDetails.sessionsCount} sessions on your account`
              : ''}
            . You'll get an email when the mentor confirms — they can also propose a new time by
            magic link, no login needed. The video link appears on your dashboard 15 minutes
            before.
          </p>
          {bookingDetails?.amountPaid != null && (
            <table className="data" style={{ marginBottom: 20 }}>
              <tbody>
                <tr>
                  <td>Amount paid</td>
                  <td className="num-cell" style={{ textAlign: 'right', fontWeight: 600 }}>
                    ${bookingDetails.amountPaid}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" onClick={() => navigate('/family-dashboard')}>
              Go to family dashboard
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/mentors')}>
              Browse more mentors
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorBookingSuccess;
